// extracted by mini-css-extract-plugin
export var alternativeBenefits = "KspList-module--alternativeBenefits--34027";
export var animateOpacity = "KspList-module--animateOpacity--9d527";
export var benefits = "KspList-module--benefits--1413c";
export var description = "KspList-module--description--65420";
export var itemList = "KspList-module--itemList--9c467";
export var items = "KspList-module--items--8a5fc";
export var kspItemAnimation = "KspList-module--kspItemAnimation--0c8f6";
export var kspItemNotVisited = "KspList-module--kspItemNotVisited--3ab09";
export var kspList = "KspList-module--kspList--09d0e";
export var sectionTitle = "KspList-module--sectionTitle--76bec";